import { LocalStorageService } from "@/Services/LocalStorageService";

import { LocalStorageKey } from "@/Modules/App/Models/Localstorage/LocalStorageKey";
import { LocalStorageNamespace } from "@/Modules/App/Models/Localstorage/LocalStorageNamespace";

import useAuthStore from "@/Modules/Auth/Store";

function clearUserTokenAH(): void {
  const authStore = useAuthStore();
  const authLocalStorageService: LocalStorageService = new LocalStorageService(LocalStorageNamespace.AUTH);

  authStore.userToken = null;
  authLocalStorageService.delete(LocalStorageKey.USER_TOKEN);
  authLocalStorageService.clear();
}

export default clearUserTokenAH;
